<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box" v-if="form_no!='' && this.show_details_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>1st Installment Payment</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-form :action="url" @submit="payment" name="paytmform" method="POST">
                    <v-card class="box" v-if="this.show_details_card">
                        <v-row dense justify="center">
                            <v-col cols="12" sm="3">
                                <v-text-field label="Name" class="padding-bot" readonly outlined dense v-model="fees_student_master_details.name"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field label="Admission Year" class="padding-bot" readonly outlined dense v-model="fees_student_master_details.learner_addmission_year"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="1" md="1">
                                <v-text-field label="Standard" class="padding-bot" readonly outlined dense v-model="fees_student_master_details.standard"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="1" md="1">
                                <v-text-field label="Quota" class="padding-bot" readonly outlined dense v-model="fees_student_master_details.quota"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field label="Primary Email" class="padding-bot" readonly outlined dense v-model="fees_student_master_details.personal_email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="1" md="1">
                                <v-text-field label="Phone No" class="padding-bot" readonly outlined dense v-model="fees_student_master_details.mobile_no"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense justify="center" v-if="applicationstatus">
                            <p><strong>Your Application Form Status Is - {{applicationstatus}}</strong></p>
                        </v-row>
                    </v-card>

                    <v-card v-if="stud_name != null" class="box">
                        <span v-if="stud_name != null">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field label="Amount To Pay" v-model="fees_to_pay" placeholder="123" dense outlined rounded readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense justify="center">
                                <!-- <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        label="* Mode Amount"
                                        v-model="inputs.amount"
                                        placeholder="123"
                                        @change="calReceiptAmount"
                                        :rules="[v => !!v || 'Mode amount is required']"
                                        type="number"
                                        name="mode_amount"
                                        dense
                                        rounded
                                        outlined
                                        hint="Mode amount is required"
                                    ></v-text-field>
                                </v-col> -->
                                <!-- <v-col cols="12" sm="6" md="6">
                                    <v-text-field rounded label="Amount" placeholder="20000" name="receipt_amount" v-model="receipt_amount" :rules="[v => !!v || 'Amount is required']" required readonly dense filled outlined></v-text-field>
                                </v-col> -->
                            </v-row>
                           <!--  <v-row dense> </v-row> -->
                            <input type="hidden" v-model="ay" name="academicyear" />
                            <input type="hidden" v-model="form_no" name="application_form_id" />
                            <input type="hidden" v-model="receipt_amount" name="receipt_amount" />

                            <input type="hidden" :value="orgid" name="orgid" />
                            <input type="hidden" :value="std_id" name="std_id" />
                            <input type="hidden" :value="tenantid" name="tenantid" />
                            <input type="hidden" :value="uid" name="uid" />
                            <input type="hidden" :value="admission_form" name="admission_form" />
                            <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                            <input type="hidden" :value="hash_val" name="hash_val" />
                           
                           



                            <span v-if="stud_name != null && !hide_component">
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Fees Component</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table dense class="elevation-1 table-container">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="toolbar">
                                                        <center><strong>Component</strong></center>
                                                    </th>
                                                    <th class="toolbar">
                                                        <center><strong>Actual</strong></center>
                                                    </th>
                                                    <!-- <th class="toolbar">
                                                  <center><strong>Paid</strong></center>
                                              </th>
                                              <th class="toolbar">
                                                  <center><strong>Balance</strong></center>
                                              </th> -->
                                                    <th class="toolbar">
                                                        <center><strong>Pay Now</strong></center>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- {{ matrix }} -->
                                                <tr v-for="comp in installments_details" :key="comp.id">
                                                    <input type="hidden" name="fees_component_ay_id" :value="comp.id" />
                                                    <td>{{ comp.feescomponent }}</td>
                                                    <td>{{ comp.total_fees_amount }}</td>
                                                    <td>
                                                        {{ comp.current_amount }}
                                                        <!-- <input class="input text-center" type="number" @change="calCompTotal" v-model="comp.current_amount" name="amount_paid" :rules="[v => !!v || 'Required' || v >= 0]" /> -->
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>{{ comp_total.name }}</td>
                                                    <td>{{ comp_total.amount }}</td>
                                                    <td>{{ comp_total.current_amount }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr />
                                </v-col>
                            </span>
                            
                        </span>
                    </v-card>
                    <v-card-actions>
                                <v-spacer> </v-spacer>
                                <span v-if="this.is_rte_quota == false">
                                    <v-btn v-if="pgs.includes('PayTM')" type="submit" rounded :disabled="!disable_pay" :loading="loader" class="button" :color="disable_pay ? '' : 'grey lighten-1'">Pay Fee (PAYTM)</v-btn>
                                    <v-btn v-if="pgs.includes('CCAVENUE')" type="button" rounded @click="payWithCCAvenue()" :disabled="!disable_pay" :loading="loader" class="button">
                                        Pay Fee(CCAvenue)
                                    </v-btn>
                                    <v-btn v-if="pgs.includes('BillDesk')" type="button" rounded @click="payWithBillDesk()" :disabled="!disable_pay" :loading="loader" class="button">
                                        Pay Fee(BillDesk)
                                    </v-btn>
                                </span>
                                <span v-else>
                                    <v-btn type="submit" rounded v-if="this.is_rte_quota" :loading="loader" class="button" :color="disable_pay ? '' : 'grey lighten-1'">Pay Fee</v-btn>
                                </span>
                                <v-spacer> </v-spacer>
                            </v-card-actions>
                </v-form>
                <v-form v-if="ccUrl" :action="ccUrl" method="POST" name="ccavenueform">
                    <input type="hidden" name="encRequest" :value="encRequest" />
                    <input type="hidden" name="access_code" :value="accessCode" />
                </v-form>
            </v-card>

            <v-dialog v-model="show_username" class="card-container" max-width="600px" v-if="show_username == true">
                <v-card class="box">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Credentials
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="8">
                                <p><b>Student Username - {{student_username}}</b></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense v-if="parent_username">
                            <v-col cols="12" sm="8">
                                <p><b>Parent Username - {{parent_username}}</b></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <center>Note* - Username And Password Are Same ....</center>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="button" @click="show_username= false">Close</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            is_rte_quota: false,
            fetch_loader: false,
            show_username: false,
            parent_username: "",
            student_username: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            headers: [
                { text: "Title", value: "title" },
                { text: "Description", value: "description" },
            ],
            inputs: [
                {
                    amount: 0,
                },
            ],
            search: "",
            aylist: [],
            ay: "",
            form_no_list: [],
            form_no: "",
            show_details_card: false,
            fees_student_master_details: [],
            receipt_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            menu11: false,
            menu12: false,
            dialog: false,
            fine_amount: "",
            excess_amount: "",
            comp_total: null,
            stud_id: null,
            fees_to_pay: null,
            payment_mode_list: [],
            inputs: [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }],
            stud_name: null,
            amount: "",
            org_id: null,
            installments_details: [],
            mode_list: [],
            bank_list: [],
            receipt_amount: 0,
            stud_standard: "",
            stud_quota: "",
            disable_pay: true,
            applicationstatus: "",
            orgid:null,
            std_id:null,
            tenantid:null,
            uid:null,
            hash_val:null,
            admission_form:null,
            url:null,
            matrix:null,
            matrix_pg_list:null,
            encRequest: null,
            accessCode: null,
            ccUrl: null,
            ccInitiateUrl: null,
            billdeskMsg: null,
            pgs: [],
            hide_component:false,

        }),
        created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_first_inst_payment";
            this.ccInitiateUrl = process.env.VUE_APP_API_URL + "/paymentGatewayCCAvenue/ccavenue_first_inst_payment";
        },
        methods: {
            payment() {
                var formData = new FormData(paytmform);
                console.log("formData");
                console.log(formData);
                this.loader = false;
            },
            // submit(){
            //     // var form = document.getElementById("payment-form");
            //     // var formData = new FormData(form);
            //     // if (this.org_id != "zeal") {
            //     //     formData.append("mode_date", this.receipt_date);
            //     // }
            //     // //  return
            //     // this.loader = true;
            //     // axios
            //     //     .post("AdmissionForm/saveApplicationFormFees", formData)
            //     //     .then((res) => {
            //     //         if (res.data.flag == "YES") {
            //     //             //this.name=
            //     //             this.showSnackbar("#4CAF50", "Payment Successful...");
            //     //             this.parent_username = res.data.parent_username;
            //     //             this.student_username = res.data.student_username;
            //     //             this.show_username = true;
            //     //             this.loader = false;
            //     //             //  alert("status::"+res.data.status.message)
            //     //             this.clearData();

            //     //             //  this.onload();
            //     //             return;
            //     //             // alert("success")
            //     //         } else {
            //     //             this.clearData();
            //     //             //this.showcomponent=true;
            //     //         }
            //     //     })
            //     //     .catch((error) => {
            //     //         window.console.log(error);
            //     //     })
            //     //     .finally(() => {
            //     //         //close loader
            //     //         this.loader = false;
            //     //         //alert("done")
            //     //     });
            //     // return;

            //     var form = document.getElementById("payment-form");
            //     // var formData = new FormData(form);

            //     var formData = new FormData(form);
            //     console.log("formData");
            //     console.log(formData);
            //     this.loader = false;
            // },

            payWithCCAvenue() {
                this.loader = true;

                let formData = new FormData();
                formData.append("orgid", this.orgid);
                formData.append("tenantid", this.tenantid);
                formData.append("uid", this.uid);
                formData.append("amount", this.receipt_amount);
                formData.append("std_id", this.std_id);
                formData.append("application_form_id", this.form_no);
                formData.append("json_pre_trans_data", this.matrix_pg_list);
                formData.append("admission_form", this.admission_form);
                formData.append("hash_val", this.hash_val);
                formData.append("academicyear", this.ay);
                formData.append("purpose", "FIRST INSTALLMENT Fees");

                axios.post(this.ccInitiateUrl, formData)
                    .then(res => {
                        if(res.data.statusCode == "200"){
                            this.encRequest = res.data.encRequest;
                            this.accessCode = res.data.accessCode;
                            this.ccUrl = res.data.ccUrl;

                            this.$nextTick(() => {
                                document.ccavenueform.submit();
                            });
                        }else{
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong")
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    })
            },

            payWithBillDesk() {
                this.loader = true;

                let formData = new FormData();
                formData.append("orgid", this.orgid);
                formData.append("tenantid", this.tenantid);
                formData.append("uid", this.uid);
                formData.append("amount", this.receipt_amount);
                formData.append("std_id", this.std_id);
                formData.append("application_form_id", this.form_no);
                formData.append("json_pre_trans_data", this.matrix_pg_list);
                formData.append("admission_form", this.admission_form);
                formData.append("hash_val", this.hash_val);
                formData.append("academicyear", this.ay);

                axios.post("/paymentGatewayBillDesk/billDeskFirstInstallment",  formData)
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.billdeskMsg = res.data.billdeskMsg
                            this.startBillDesk()
                        } else {
                            this.showSnackbar("red", res.data.msg || "BillDesk init failed")
                        }
                    })

                    .catch(err => {
                        console.error(err);
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    })
            },

            startBillDesk() {
                if (!this.billdeskMsg) {
                    this.showSnackbar("red", "Payment data missing")
                    return
                }

                bdPayment.initialize({
                    msg: this.billdeskMsg,
                    options: {
                        enableChildWindowPosting: true,
                        enablePaymentRetry: true,
                        retry_attempt_count: 2
                    }
                });
            },

            clearData() {
                this.fees_student_master_details = [];
                this.student_receipt_details = [];
                this.show_details_card = false;
                //  this.show_receipts_btn = false;
                //this.show_installments_btn = false;
                this.installment_list = [];
                this.installments_details = [];
                this.mode_list = [];
                this.bank_list = [];
                this.installment_details_list = [];
                this.stud_name = null;
                this.comp_total = "";
                this.stud_id = "";
                (this.inputs = [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }]), (this.outstanding = null);
                this.receipt_amount = 0;
                (this.fine_amount = ""), (this.excess_amount = "");
                this.receipt_date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
                (this.stud_standard = ""), (this.stud_quota = "");
            },
            calCompTotal() {
                this.comp_total.current_amount = 0;
                for (var i = 0; i < this.installments_details.length; i++) {
                    this.comp_total.current_amount += parseFloat(this.installments_details[i].current_amount);
                }
                this.checkPay();
            },
            checkPay() {
                //alert("this.receipt_amount ---"+this.receipt_amount )
                //alert("this.comp_total.current_amount ---"+this.comp_total.current_amount )
                if (this.receipt_amount == this.comp_total.current_amount) {
                    this.disable_pay = true;
                } else if (this.receipt_amount > this.comp_total.current_amount) {
                    this.excess_amount = this.receipt_amount - this.comp_total.current_amount;
                    return;
                } else {
                    this.disable_pay = false;
                }
            },
            proceed() {
                const data = {
                    ay: this.ay,
                    application_form: this.form_no,
                };
                this.overlay = true;
                this.fetch_loader = true;
                axios
                    .post("/AdmissionForm/getApplicationFormData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.applicationstatus = res.data.applicationstatus;
                            this.stud_standard = res.data.stud_standard;
                            this.stud_quota = res.data.stud_quota;
                            (this.show_details_card = true), (this.fees_student_master_details = res.data.fees_student_master_details);
                            this.stud_name = res.data.fees_student_master_details.name;
                            this.installments_details = res.data.installments;
                            this.matrix = res.data.matrix
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.comp_total = res.data.comp_total[0];
                            this.is_rte_quota = res.data.is_rte_quota;
                            this.fees_to_pay = res.data.fees_to_pay;
                            this.orgid = res.data.orgid;
                            this.std_id = res.data.std_id
                            this.tenantid = res.data.tenantid;
                            this.uid = res.data.uid;
                            this.hash_val = res.data.hash_val;
                            this.admission_form = res.data.admission_form
                            this.pgs = res.data.pgs
                            if(this.fees_to_pay){
                                this.receipt_amount = parseFloat(this.fees_to_pay);
                                var pay_comp_now = this.receipt_amount;

                                for (var i = 0; i < this.installments_details.length; i++) {
                                    this.installments_details[i].current_amount = 0;
                                    if (pay_comp_now >= this.installments_details[i].total_fees_amount) {
                                        this.installments_details[i].current_amount = this.installments_details[i].total_fees_amount;
                                        this.matrix[i].amount = this.installments_details[i].total_fees_amount;
                                        pay_comp_now = pay_comp_now - this.installments_details[i].total_fees_amount;
                                    } else {
                                        this.installments_details[i].current_amount = pay_comp_now;
                                        this.matrix[i].amount = pay_comp_now;
                                        pay_comp_now = 0;
                                        //break
                                    }
                                    this.comp_total.current_amount += this.installments_details[i].current_amount;
                                }
                                this.calCompTotal();
                            }
                            this.matrix_pg_list = JSON.stringify(this.matrix)

                            if (this.is_rte_quota == true)
                                [
                                    //this.calReceiptAmount(),
                                    (this.disable_pay = false),
                                ];
                        } else {
                            this.stud_standard = "";
                            this.stud_quota = "";
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.fetch_loader = false;
                        // this.selected_date=""
                    });
            },
            getApplicationForm(ay) {
                const data = {
                    ay: ay,
                };
                this.overlay = true;
                this.fetch_loader = true;
                (this.form_no_list = []), (this.form_no = "");
                axios
                    .post("/AdmissionForm/getApplicationFormsByAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.form_no_list = res.data.application_forms_details;
                        } else {
                            this.form_no_list = [];
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.stud_standard = "";
                            (this.stud_quota = ""), (this.form_no = "");
                        }
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.fetch_loader = false;
                        // this.selected_date=""
                    });
            },
            calReceiptAmount() {
               // this.receipt_amount = 0;
              //  this.receipt_amount = parseFloat(this.inputs.amount);
                this.receipt_amount = parseFloat(this.fees_to_pay);
                var pay_comp_now = this.receipt_amount;

                for (var i = 0; i < this.installments_details.length; i++) {
                    this.installments_details[i].current_amount = 0;
                    if (pay_comp_now >= this.installments_details[i].total_fees_amount) {
                        this.installments_details[i].current_amount = this.installments_details[i].total_fees_amount;
                        pay_comp_now = pay_comp_now - this.installments_details[i].total_fees_amount;
                    } else {
                        this.installments_details[i].current_amount = pay_comp_now;
                        pay_comp_now = 0;
                        //break
                    }
                    this.comp_total.current_amount += this.installments_details[i].current_amount;
                }
                this.calCompTotal();
            },

            addRow() {
                this.inputs.push({
                    mode: "Cash",
                    bank: "",
                    trans_id: "",
                    amount: 0,
                    mode_date: { value: "" },
                });
            },
            deleteRow(index) {
                this.inputs.splice(index, 1);
                this.calReceiptAmount();
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        },
        mounted() {
            this.ay = localStorage.getItem("ay");
            this.form_no = localStorage.getItem("application_form");
            this.hide_component = localStorage.getItem("hide_component") === "true";
            console.log("hide_component============"+this.hide_component);
            
            this.proceed();
        },
        watch: {},
    };
</script>
<style scoped>
    .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }
    input1 {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    input[type="number"] {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    .link {
        text-decoration: none !important;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .datepicker-div {
        margin-top: -20px;
    }
    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
        top: 4px;
    }
    .datepicker {
        border: 1px solid #dddddd;
        padding: 7px 0 7px;
        border-radius: 4px;
        width: 100%;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>
